<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Create Competition</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="competitionGroup" (ngSubmit)="createCompetition()">
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Name</mat-label>
                <input matInput type="text" [formControl]="competitionGroup.controls.nameControl">
            </mat-form-field>
            <mat-card-actions>
                <button class="create-button" mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!competitionGroup.valid" color="primary"><mat-icon>add_box</mat-icon>Create</button>
                <button class="create-button" mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
            </mat-card-actions>
        </form>
    </mat-card-content>
</mat-card>